import { useState } from "react";
import { useNotification } from "../../../hooks/useNotification";
import { useProcessSaleInvoiceFulfillmentMutation } from "../../../store/apiSlice/invoiceApiSlice";

/**
 * Confirm and run Process Fulfillment for invoices and/or invoice lines.
 *
 * @returns {object} confirm state and submit helpers
 */
export const useProcessSaleInvoiceFulfillment = ({ onComplete } = {}) => {
  const notify = useNotification();
  const [processFulfillment, { isLoading }] = useProcessSaleInvoiceFulfillmentMutation();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [payload, setPayload] = useState({ invoice_ids: [], invoice_line_ids: [] });

  const invoiceCount = payload.invoice_ids?.length || 0;
  const lineCount = payload.invoice_line_ids?.length || 0;

  const openConfirm = ({ invoiceIds = [], invoiceLineIds = [] } = {}) => {
    if (!invoiceIds.length && !invoiceLineIds.length) return;
    setPayload({ invoice_ids: invoiceIds, invoice_line_ids: invoiceLineIds });
    setIsConfirmOpen(true);
  };

  const closeConfirm = () => setIsConfirmOpen(false);

  const confirm = async () => {
    try {
      const res = await processFulfillment(payload).unwrap();
      const summary = res?.summary || {};
      notify({
        type: summary.failed ? "warning" : "success",
        message: res?.message ||
          `${summary.success || 0} succeeded, ${summary.failed || 0} failed, ${
            summary.skipped || 0
          } skipped.`,
      });
      setIsConfirmOpen(false);
      onComplete?.();
    } catch (error) {
      notify({
        type: "error",
        message:
          error?.data?.detail ||
          error?.data?.invoice_ids?.[0] ||
          "Failed to process fulfillment.",
      });
    }
  };

  return {
    closeConfirm,
    confirm,
    invoiceCount,
    isConfirmOpen,
    isLoading,
    lineCount,
    openConfirm,
  };
};
